import React, { useState, useRef, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { DateTime } from "luxon";
import { toast } from "react-toastify";
import { getData, postData } from '../../../webService/webservice.js';
import '../../../styles/Auth/expense.css';
const ExpensePage = ({ expenses, totalCount, totalPages, currentPage, setCurrentPage, filters,
    setFilters,
    setRefreshKey,
    topFilter,
    searchQuery,
    setSearchQuery }) => {
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Expense',
        'Employee Name',
        'Description',
        'Date',
        'Amount',
        'Payment Mode',
        'Expense Type',
        'Invoice',
    ];
    const [isAddExpense, setIsAddExpense] = useState(false);
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(5);
    const [employees, setEmployees] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [customExpense, setCustomExpense] = useState("");
    const [expenseOptions, setExpenseOptions] = useState([]);
    const [formData, setFormData] = useState({
        expenseName: '',
        description: '',
        amount: "",
        date: "",
        expenseType: "",
        invoiceNo: "",
        paymentMode: "",
        employeeId: "",
        description: ""
    });

    useEffect(() => {
        const fetchExpenseCategories = async () => {
            try {
            const token = sessionStorage.getItem("sessionToken");

            const response = await getData(
                "expenses/expense-categories",
                token
            );

            setExpenseOptions(response.data || []);

            } catch (error) {
                console.error("Fetch Expense Categories Error:", error);
            }
        };

        fetchExpenseCategories();
    }, []);


    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };
    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleAddExpense = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = sessionStorage.getItem("sessionToken");
            let finalExpenseName = formData.expenseName;
            
            // 🔥 If user typed a new expense
            if (finalExpenseName === "__other__") {
                if (!customExpense.trim()) {
                    toast.error("Please enter expense name");
                    setLoading(false);
                    return;
                }

                // Save new expense category (backend handles duplicates)
                await postData(
                    "expenses/expense-categories/add",
                    { name: customExpense.trim() },
                    token
                );

                finalExpenseName = customExpense.trim();
            }
            const expenseData = {
                expenseName: finalExpenseName,
                description: formData.description,
                date: formData.date,
                paymentMode: formData.paymentMode,
                amount: formData.amount,
                expenseType: formData.expenseType,
                invoiceNo: formData.invoiceNo,
                employeeId: formData.employeeId,
            };
            console.log("Sending Expense data:", expenseData);
            const response = await postData('expenses/', expenseData, token);
            toast.success(response.message || 'Expense added successfully');
            setFormData({
                expenseName: '',
                description: '',
                amount: "",
                date: "",
                expenseType: "",
                invoiceNo: "",
                paymentMode: "",
                employeeId: ""
            });
            setIsAddExpense(false);
            triggerRefresh();
            await new Promise((res) => setTimeout(res, 2000));
        } catch (error) {
            console.error('Add Product Error:', error);
            toast.error(error.message || 'Add Product Failed');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!formData.date) {
            const today = new Date().toISOString().split("T")[0]; // yyyy-mm-dd
            setFormData((prev) => ({ ...prev, date: today }));
        }
    }, [formData.date]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const params = {};
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('users/users', params, token);
                const results = data?.data?.[0].paginatedResults || [];
                setEmployees(results);
            } catch (error) {
                console.error("Failed to load categories", error);
            }
        };
        fetchUsers();
    }, []);

    useEffect(() => {
        if (topFilter === "all" && filters.startDate && filters.endDate) {
            setCurrentPage(1);
            setRefreshKey(prev => prev + 1);
        }
    }, [filters.startDate, filters.endDate, topFilter]);

    // const exportToExcel = () => {
    //     if (!expenses || expenses.length === 0) {
    //         alert("No data to export!");
    //         return;
    //     }

    //     const worksheetData = expenses.map((exp, index) => ({
    //         SL: index + 1,
    //         Expense: exp.expenseName,
    //         Description: exp.description,
    //         Date: exp.date ? DateTime.fromISO(exp.date).toFormat("dd-MM-yyyy") : "—",
    //         Amount: exp.amount,
    //         PaymentMode: exp.paymentMode,
    //         ExpenseType: exp.expenseType,
    //         Invoice: exp.invoiceNo ? `INV-${exp.invoiceNo}` : "Non-Billable"
    //     }));

    //     const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    //     const workbook = XLSX.utils.book_new();

    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");

    //     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    //     const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });

    //     saveAs(fileData, `Expenses_${new Date().toISOString().slice(0, 10)}.xlsx`);
    // };

    const exportToExcel = () => {
        if (!expenses || expenses.length === 0) {
            alert("No data to export!");
            return;
        }

        const { startDate, endDate } = filters;

        if (!startDate || !endDate) {
            alert("Please select Start Date and End Date!");
            return;
        }

        const from = DateTime.fromISO(startDate).startOf("day");
        const to = DateTime.fromISO(endDate).endOf("day");

        // Filter expenses based on date range
        const filteredExpenses = expenses.filter(exp => {
            if (!exp.date) return false;

            // FIX: Normalize date to avoid filtering mistakes
            const expDate = DateTime.fromISO(exp.date).startOf("day"); 

            return expDate >= from && expDate <= to;
        });

        if (filteredExpenses.length === 0) {
            alert("No expenses found for the selected date range!");
            return;
        }
        
        // Group by expenseName (but keep ALL repeated items)
        const groupedByName = filteredExpenses.reduce((acc, exp) => {
            const name = exp.expenseName || "Unknown";

            if (!acc[name]) acc[name] = [];
            acc[name].push(exp);

            return acc;
        }, {});

        const workbook = XLSX.utils.book_new();

        Object.keys(groupedByName).forEach((name) => {
            const sheetData = groupedByName[name].map((exp, index) => ({
                SL: index + 1,
                Expense: exp.expenseName,
                Description: exp.description,
                Date: exp.date 
                    ? DateTime.fromISO(exp.date).toFormat("dd-MM-yyyy")
                    : "—",
                Amount: exp.amount,
                PaymentMode: exp.paymentMode,
                ExpenseType: exp.expenseType,
                Invoice: exp.invoiceNo ? `INV-${exp.invoiceNo}` : "Non-Billable"
            }));

            const worksheet = XLSX.utils.json_to_sheet(sheetData);

            const safeSheetName = name.substring(0, 31);

            XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName);
        });

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });

        saveAs(
            fileData,
            `Expenses_${from.toFormat("ddMMyyyy")}_to_${to.toFormat("ddMMyyyy")}.xlsx`
        );
    };

    return (
        <div className='Expense-layout1'>
            <div className='Expense-content1'>
                <main className='Expense-main1'>
                    {isAddExpense ? (
                        <div className='add-Expense-form'>
                            <h3>Add Expense</h3>
                            <form className='Expense-form'>
                                <div className='Expense-form-row'>
                                    <div className="Expense-form-group">
                                        <label className="input-label">Expense</label>
                                        <select
                                        className="Expense-input"
                                        required
                                        value={formData.expenseName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData(prev => ({ ...prev, expenseName: value }));

                                            // 🔥 Clear custom input if not Other
                                            if (value !== "__other__") {
                                            setCustomExpense("");
                                            }
                                        }}
                                        >
                                        <option value="">Select Expense</option>

                                        {expenseOptions.map(exp => (
                                            <option key={exp._id} value={exp.name}>
                                            {exp.name}
                                            </option>
                                        ))}

                                        <option value="__other__">Other</option>
                                        </select>
                                        {/* <select
                                            id="expense"
                                            className="Expense-input"
                                            required
                                            value={formData.expenseName}
                                            onChange={(e) => {
                                                const selectedExpense = e.target.value;
                                                setFormData((prev) => ({ ...prev, expenseName: selectedExpense }));
                                            }}
                                        >
                                            <option value="">Select Expense</option>
                                            <option value="salary">Salary</option>
                                            <option value="incentives">Incentives</option>
                                            <option value="OT">OT</option>
                                            <option value="recreation">Recreation</option>
                                            <option value="repair & maintanence">Repair & Maintenance</option>
                                            <option value="purchase">Purchase</option>
                                            <option value="rental">Rental</option>
                                            <option value="opening & closing balance">Opening & Closing Balance</option>
                                            <option value="EB">EB</option>
                                            <option value="phone bill">Phone Bill</option>
                                            <option value="royalty">Royalty</option>
                                            <option value="GST">GST</option>
                                            <option value="advertisements">Advertisements</option>
                                            <option value="promotion">Promotion</option>
                                            <option value="miscellenous">Miscellenous</option>
                                            <option value="__other__">Other</option>
                                        </select> */}
                                        {formData.expenseName === "__other__" && (
                                        <input
                                            type="text"
                                            className="Expense-input"
                                            placeholder="Enter new expense name"
                                            value={customExpense}
                                            onChange={(e) => setCustomExpense(e.target.value)}
                                            required
                                        />
                                        )}
                                    </div>
                                    
                                    {(formData.expenseName === "Salary" || formData.expenseName === "OT" || formData.expenseName === "Incentive") && (
                                        <div className="Expense-form-group">
                                            <label className="input-label">Employee</label>
                                            <select
                                                className="Expense-input"
                                                value={formData.employeeId || ""}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        employeeId: e.target.value === "" ? null : e.target.value
                                                    }))
                                                }
                                            >
                                                <option value="">Select Employee</option>
                                                {employees.map((emp) => (
                                                    <option key={emp._id} value={emp._id}>
                                                        {emp.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                    {["advertisements", "promotion"].includes(formData.expenseName) && (
                                        <div className="Expense-form-group">
                                            <label className="input-label">Expense Name</label>
                                            <input
                                                type="text"
                                                className="Expense-input"
                                                required
                                                value={formData.description || ""}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, description: e.target.value }))
                                                }
                                            />
                                        </div>
                                    )}
                                    <div className="Expense-form-group">
                                        <label className="input-label">Date</label>
                                        <input
                                            type="date"
                                            className="Expense-input"
                                            value={formData.date || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, date: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className='Expense-form-row'>
                                    <div className='Expense-form-group'>
                                        <label className="input-label">Expense Type</label>
                                        <select
                                            id="expenseType"
                                            className="Expense-input"
                                            required
                                            value={formData.expenseType}
                                            onChange={(e) => {
                                                const selectedUnitType = e.target.value;
                                                setFormData((prev) => ({ ...prev, expenseType: selectedUnitType }))
                                            }}
                                        >
                                            <option value='' >Select Expense Type</option>
                                            <option value='Billable'>Billable</option>
                                            <option value='Non-Billable'>Non-Billable</option>
                                        </select>
                                    </div>
                                    {formData.expenseType === "Billable" && (
                                        <div className='Expense-form-group'>
                                            <label className='input-label'>Invoice No</label>
                                            <input
                                                className="Expense-input"
                                                value={formData.invoiceNo || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value)) { // only digits allowed
                                                        setFormData((prev) => ({ ...prev, invoiceNo: value }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className='Expense-form-group'>
                                        <label className='input-label'>Amount</label>
                                        <input
                                            className="Expense-input"
                                            disabled={!formData.expenseType}
                                            value={formData.amount || ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only numbers with optional decimal point
                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, amount: value }));
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className='Expense-form-group'>
                                        <label className='input-label'>Payment Mode</label>
                                        <select
                                            id="paymentMode"
                                            className="Expense-input"
                                            required
                                            disabled={!formData.amount}
                                            value={formData.paymentMode}
                                            onChange={(e) => {
                                                const selectedUnitType = e.target.value;
                                                setFormData((prev) => ({ ...prev, paymentMode: selectedUnitType }))
                                            }}
                                        >
                                            <option value='' >Select Payment Mode</option>
                                            <option value='UPI'>UPI</option>
                                            <option value='cash'>cash</option>
                                            <option value='Card'>Card</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='Expense-form-row'>
                                    <div className='Expense-form-group'>
                                        <label className='input-label'>Description</label>
                                        <textarea
                                            placeholder="Enter description"
                                            className="Expense-input"
                                            value={formData.description || ""}
                                            onChange={e => {
                                                let value = e.target.value;

                                                // Auto bullet on Enter
                                                if (value.endsWith("\n")) {
                                                    value += "• ";
                                                }
                                                setFormData(prev => ({ ...prev, description: value }));
                                            }}
                                            style={{ height: '100px' }}
                                        />
                                    </div>
                                </div>
                                <div className="Expense-buttons">
                                    <button className="add-Expense-button" type="submit" onClick={handleAddExpense} disabled={loading}
                                    >
                                        Add Expense
                                    </button>
                                    <button className="cancel-Expense-button" onClick={() => setIsAddExpense(false)} disabled={loading} >
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className='Expense-widgets'>
                                <div className='search-option' style={{ display: "flex", gap: "10px", textAlign: "center" }}>
                                    <h3>Expense</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="Expense-search-input"
                                        value={searchQuery}
                                        onChange={(e) => {
                                            setSearchQuery(e.target.value);
                                            setCurrentPage(1);
                                            setRefreshKey(prev => prev + 1);
                                        }}
                                    />
                                </div>
                                <div className="expense-date-filter" style={{ display: "flex", gap: "15px", alignItems: "flex-end" }}>
    
                                    {/* Start Date */}
                                    <div className="Start-Date">
                                        <label>Start Date</label>
                                        <input
                                            type="date"
                                            className="expense-date-input"
                                            disabled={topFilter !== "all"}
                                            value={filters.startDate || ""}
                                            onChange={(e) => {
                                                setFilters(prev => ({ ...prev, startDate: e.target.value }));
                                            }}
                                            style={{
                                                background: "#e6cf80",
                                                border: "none",
                                                padding: "10px",
                                                borderRadius: "10px",
                                                cursor: topFilter !== "all" ? "not-allowed" : "pointer"
                                            }}
                                        />
                                    </div>

                                    {/* End Date */}
                                    <div className="End-Date">
                                        <label>End Date</label>
                                        <input
                                            type="date"
                                            className="expense-date-input"
                                            value={filters.endDate || ""}
                                            onChange={(e) => {
                                                setFilters(prev => ({ ...prev, endDate: e.target.value }));
                                            }}
                                            style={{
                                                background: "#e6cf80",
                                                border: "none",
                                                padding: "10px",
                                                borderRadius: "10px"
                                            }}
                                        />
                                    </div>

                                    {/* Export Button */}
                                    <div className="Expense-Export-Button">
                                        <button
                                            className="add-btn-Expense"
                                            onClick={exportToExcel}
                                            style={{ padding: "10px 18px", borderRadius: "10px" }}
                                        >
                                            Export
                                        </button>
                                    </div>

                                </div>

                                <div className="add-Expense-buttons">
                                    <button className="add-btn-Expense" onClick={() => setIsAddExpense(true)}>+ Add New</button>
                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!expenses || expenses.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={8}>
                                                    <Typography
                                                        sx={{
                                                            textAlign: 'center',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '20px',
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        No expenses found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            expenses.map((expense, index) => (
                                                <TableRow key={expense._id}>
                                                    <TableCell>
                                                        {limit === "all"
                                                            ? index + 1
                                                            : (currentPage - 1) * Number(limit) + index + 1}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{expense.expenseName}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {expense.employee?.[0]?.name || "—"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{expense.description}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {expense.date
                                                                ? DateTime.fromISO(expense.date).toFormat("dd LLL yyyy")
                                                                : "—"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>₹{expense.amount}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{expense.paymentMode}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{expense.expenseType}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            INV-{expense.invoiceNo || "Non-Billable"}
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                            <div className="Expense-bottom">
                                <div className="Expense-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="Expense-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="Expense-section spacer"></div>
                                <div className="Expense-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {limit > 5 && expenses.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Expenses
                                    </Typography>
                                </div>
                            )}
                        </>
                    )}
                </main>
            </div>
        </div >
    );
}
export default ExpensePage;